import React, { useContext } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { useMediaQuery } from 'react-responsive'
import { useSwipeable } from 'react-swipeable'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import { motion, AnimatePresence } from 'framer-motion'
import { GlobalDispatchContext, GlobalStateContext } from '../../contexts/GlobalContextProvider'
import Menu from './Menu'
import flatListToHierarchical from '../../utils/flatListToHierarchical'

const DrawerWrap = styled((props) => <motion.div {...props} />)`
  ${tw`fixed lg:right-0 top-0 pt-20 h-full bg-colekt-dark-gray text-almost-white font-extended z-50`}
  max-width: 500px;
`

const CloseButton = styled.button`
  ${tw`p-6 pl-6 text-lg uppercase tracking-wider  focus:outline-none absolute top-0 left-0`}
`

export default function DrawerMenu() {
  const data = useStaticQuery(graphql`
    fragment MenuItems on WpMenuItem {
      key: id
      parentId
      title: label
      url
    }

    query {
      primaryMenu: allWpMenuItem(filter: { locations: { eq: SHOP_MENU } }) {
        nodes {
          ...MenuItems
        }
      }
      secondaryMenu: allWpMenuItem(filter: { locations: { eq: SECONDARY_MENU } }) {
        nodes {
          ...MenuItems
        }
      }
      categoryMenu: allWpMenuItem(filter: { locations: { eq: CATEGORY_MENU } }) {
        nodes {
          ...MenuItems
        }
      }
      wp {
        generalSettings {
          url
        }
      }
    }
  `)

  const dispatch = useContext(GlobalDispatchContext)
  const state = useContext(GlobalStateContext) || { drawerMenuIsOpen: false }
  const { drawerMenuIsOpen } = state

  const primaryMenuItems = flatListToHierarchical(data.primaryMenu.nodes)
  const secondaryMenuItems = flatListToHierarchical(data.secondaryMenu.nodes)
  // const categoryMenuItems = flatListToHierarchical(data.categoryMenu.nodes)
  const wordPressUrl = data.wp.generalSettings.url.slice(0, -3)

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })

  const handlers = isTabletOrMobile
    ? useSwipeable({
        onSwipedLeft: () => dispatch({ type: 'TOGGLE_DRAWER_MENU' }),
        preventDefaultTouchmoveEvent: true,
        trackMouse: true,
      })
    : useSwipeable({
        onSwipedRight: () => dispatch({ type: 'TOGGLE_DRAWER_MENU' }),
        preventDefaultTouchmoveEvent: true,
        trackMouse: true,
      })

  return (
    <div {...handlers}>
      <AnimatePresence>
        {drawerMenuIsOpen && (
          <DrawerWrap
            className="aside__width blackonwhite"
            initial={{ x: isTabletOrMobile ? -500 : 500 }}
            animate={{ x: 0 }}
            exit={{ x: isTabletOrMobile ? -500 : 500 }}
            transition={{ duration: 0.5, type: 'spring', bounce: 0 }}
            id="drawer"
          >
            <CloseButton
              type="button"
              onClick={() => {
                dispatch({ type: 'TOGGLE_DRAWER_MENU' })
              }}
            >
              Close
            </CloseButton>
            <Menu menu={primaryMenuItems} wordPressUrl={wordPressUrl} />
            <Menu menu={secondaryMenuItems} wordPressUrl={wordPressUrl} />
          </DrawerWrap>
        )}
      </AnimatePresence>
    </div>
  )
}
